import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export const IssueOptionTabs = ({ tabs, activeKind, onSelect, disabled }) => {
    const options = tabs.map(tab => ({ key: tab.kind, text: tab.label, value: tab.kind }));

    return (
        <div className="issue-options-tabs">
            <Dropdown
                id="issue-options-selector"
                className="issue-options-select"
                selection
                disabled={disabled}
                options={options}
                value={activeKind}
                onChange={(e, { value }) => onSelect(value)}
                aria-label="Issue option type"
            />
        </div>
    );
};
